
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
    fontSize:'14px',
    overflowX:'auto'
  },

  items: {
    padding: '0%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    textAlign:'left'
    
  },

  item_body: {
    padding: '2px ',
    width:'100%',
    marginBottom:'2px',
    },

  main_header: {
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
  },
  sub_header: {
    borderBottom:'2px solid',
    textAlign:'left',
    fontSize:'20px',
    fontWeight:'bold',
    marginBottom:'15px',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },
  button_view:{
    textAlign:'right',
    fontSize:'35px',
    padding:'25px',
  },
  input_button:{
    backgroundColor: '#3CB3E2',
    width:'108px',
    color:'white',
    borderRadius: '2px',
    marginBottom:'4px',
    borderRadius:'4px',
    marginTop:'4px',
    fontSize:'14px',
    fontWeight:'bold',
    padding:'5px 5px ',
  },
  input: {
    width: '90%',
    marginBottom:'2px'
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionExpense/style.js